module.exports = __webpack_public_path__ + "img/sameday_cod_dg.2b9dd344.png";